import * as api from '@gitbook/api-client';
import { assertNever } from '@gitbook/util-ts';

export function getLabelsForScope(scope: api.IntegrationScope): {
    title: string;
    description: string;
} {
    switch (scope) {
        case api.IntegrationScope.SpaceContentRead:
            return {
                title: 'Read content',
                description: 'Can access content of a space.',
            };
        case api.IntegrationScope.SpaceContentWrite:
            return {
                title: 'Write content',
                description: 'Can update the content of a space.',
            };
        case api.IntegrationScope.SpaceMetadataRead:
            return {
                title: 'Read space metadata',
                description: 'Can access the space information.',
            };
        case api.IntegrationScope.SpaceMetadataWrite:
            return {
                title: 'Write space metadata',
                description: 'Can update the space information (title, etc).',
            };
        case api.IntegrationScope.SpaceGitSync:
            return {
                title: 'Synchronize with a Git provider',
                description:
                    'Allows synchronization to be set up on the space with a Git provider. This a single use scope which once installed on a space will prevent other integrations with this scope to be installed on the same space.',
            };
        case api.IntegrationScope.SiteScriptInject:
            return {
                title: 'Inject scripts in published content',
                description: 'Can inject scripts into the published version of the site.',
            };
        case api.IntegrationScope.SiteScriptCookies:
            return {
                title: 'Write cookies from injected scripts',
                description:
                    "Scripts that needs cookies to work when injected in a site's published version can write then on the user's browser. Will display a cookie banner on each page of the published version.",
            };
        case api.IntegrationScope.SiteVisitorAuth:
            return {
                title: 'Authenticated access',
                description: 'Authenticate visitors who access the site using the integration',
            };
        case api.IntegrationScope.SiteViewsRead:
            return {
                title: 'Read site page views',
                description: 'Can query and listen to page views on a site.',
            };
        case api.IntegrationScope.SiteMetadataRead:
            return {
                title: 'Read site metadata',
                description: 'Can access the site information.',
            };
        case api.IntegrationScope.OpenapiRead:
            return {
                title: 'Read OpenAPI specs',
                description: 'Can access the OpenAPI specs.',
            };
        case api.IntegrationScope.OpenapiWrite:
            return {
                title: 'Write OpenAPI specs',
                description: 'Can update the OpenAPI specs.',
            };
        case api.IntegrationScope.SiteAdaptiveRead:
            return {
                title: 'Read site adaptive schema',
                description: 'Can access adaptive content schemas for the site.',
            };
        case api.IntegrationScope.SiteAdaptiveWrite:
            return {
                title: 'Write site adaptive schema',
                description: 'Can update adaptive content schemas for the site.',
            };
        case api.IntegrationScope.ConversationsIngest:
            return {
                title: 'Ingest conversations',
                description: 'Can ingest conversations for Docs Agents.',
            };
        case api.IntegrationScope.PageFeedbackRead:
            return {
                title: 'Read page feedback',
                description: 'Can listen to page feedback events on a site.',
            };
        default:
            assertNever(scope);
    }
}
